<div class="metadata-div">

  <span class="input-field-label" [matTooltip]="label ? label : ''" matTooltipPosition="above">
    <span *ngIf="visibility === 'MT_K'">*</span>{{label}}
  </span>

<!--  <div *ngIf="visibility === 'MT_O'" class="only-read-metadata-data-div">-->
<!--    {{humanvalue}}-->
<!--  </div>-->

  <app-meta-data-onlyread *ngIf="visibility === 'MT_O'" [value]="humanvalue" [title]="label"></app-meta-data-onlyread>

  <mat-form-field *ngIf="visibility === 'MT_K' || visibility === 'MT_M'">
    <textarea matInput #input
              [formControl]="textareaFormControl"
              [value]="value"
              [escapeAwareMaxLength]="1000"
              cdkTextareaAutosize
              cdkAutosizeMaxRows="16"
              (input)="onChangeValue(input.value); onChangeHumanValue(input.value)"></textarea>
    <mat-hint align="end">{{input.value.length}}/1000</mat-hint>
    <mat-error *ngIf="textareaFormControl.hasError('required')">
      {{'MANDATORY_FIELD' | translate}}
    </mat-error>
  </mat-form-field>

</div>
